/**
 * Currency default detection based on browser locale and country information
 */

// Map of country codes to their primary currencies
const countryToCurrency: Record<string, string> = {
  // Africa
  'DZ': 'DZD', // Algeria
  'AO': 'AOA', // Angola
  'BJ': 'XOF', // Benin
  'BW': 'BWP', // Botswana
  'BF': 'XOF', // Burkina Faso
  'BI': 'BIF', // Burundi
  'CM': 'XAF', // Cameroon
  'CV': 'CVE', // Cape Verde
  'CF': 'XAF', // Central African Republic
  'TD': 'XAF', // Chad
  'KM': 'KMF', // Comoros
  'CG': 'XAF', // Congo
  'CD': 'CDF', // Congo (DRC)
  'DJ': 'DJF', // Djibouti
  'EG': 'EGP', // Egypt
  'GQ': 'XAF', // Equatorial Guinea
  'ER': 'ERN', // Eritrea
  'ET': 'ETB', // Ethiopia
  'GA': 'XAF', // Gabon
  'GM': 'GMD', // Gambia
  'GH': 'GHS', // Ghana
  'GN': 'GNF', // Guinea
  'GW': 'XOF', // Guinea-Bissau
  'CI': 'XOF', // Ivory Coast
  'KE': 'KES', // Kenya
  'LS': 'LSL', // Lesotho
  'LR': 'LRD', // Liberia
  'LY': 'LYD', // Libya
  'MG': 'MGA', // Madagascar
  'MW': 'MWK', // Malawi
  'ML': 'XOF', // Mali
  'MR': 'MRU', // Mauritania
  'MU': 'MUR', // Mauritius
  'MA': 'MAD', // Morocco
  'MZ': 'MZN', // Mozambique
  'NA': 'NAD', // Namibia
  'NE': 'XOF', // Niger
  'NG': 'NGN', // Nigeria
  'RW': 'RWF', // Rwanda
  'ST': 'STN', // São Tomé and Príncipe
  'SN': 'XOF', // Senegal
  'SC': 'SCR', // Seychelles
  'SL': 'SLE', // Sierra Leone
  'SO': 'SOS', // Somalia
  'ZA': 'ZAR', // South Africa
  'SS': 'SSP', // South Sudan
  'SD': 'SDG', // Sudan
  'SZ': 'SZL', // Eswatini
  'TZ': 'TZS', // Tanzania
  'TG': 'XOF', // Togo
  'TN': 'TND', // Tunisia
  'UG': 'UGX', // Uganda
  'ZM': 'ZMW', // Zambia
  'ZW': 'ZWL', // Zimbabwe
  
  // Europe
  'AL': 'ALL', // Albania
  'AD': 'EUR', // Andorra
  'AT': 'EUR', // Austria
  'BY': 'BYN', // Belarus
  'BE': 'EUR', // Belgium
  'BA': 'BAM', // Bosnia and Herzegovina
  'BG': 'BGN', // Bulgaria
  'HR': 'EUR', // Croatia
  'CY': 'EUR', // Cyprus
  'CZ': 'CZK', // Czech Republic
  'DK': 'DKK', // Denmark
  'EE': 'EUR', // Estonia
  'FI': 'EUR', // Finland
  'FR': 'EUR', // France
  'DE': 'EUR', // Germany
  'GR': 'EUR', // Greece
  'HU': 'HUF', // Hungary
  'IS': 'ISK', // Iceland
  'IE': 'EUR', // Ireland
  'IT': 'EUR', // Italy
  'XK': 'EUR', // Kosovo
  'LV': 'EUR', // Latvia
  'LI': 'CHF', // Liechtenstein
  'LT': 'EUR', // Lithuania
  'LU': 'EUR', // Luxembourg
  'MT': 'EUR', // Malta
  'MD': 'MDL', // Moldova
  'MC': 'EUR', // Monaco
  'ME': 'EUR', // Montenegro
  'NL': 'EUR', // Netherlands
  'MK': 'MKD', // North Macedonia
  'NO': 'NOK', // Norway
  'PL': 'PLN', // Poland
  'PT': 'EUR', // Portugal
  'RO': 'RON', // Romania
  'RU': 'RUB', // Russia
  'SM': 'EUR', // San Marino
  'RS': 'RSD', // Serbia
  'SK': 'EUR', // Slovakia
  'SI': 'EUR', // Slovenia
  'ES': 'EUR', // Spain
  'SE': 'SEK', // Sweden
  'CH': 'CHF', // Switzerland
  'TR': 'TRY', // Turkey
  'UA': 'UAH', // Ukraine
  'GB': 'GBP', // United Kingdom
  'VA': 'EUR', // Vatican City
  
  // Americas
  'US': 'USD', // United States
  'CA': 'CAD', // Canada
  'MX': 'MXN', // Mexico
  'GT': 'GTQ', // Guatemala
  'BZ': 'BZD', // Belize
  'SV': 'USD', // El Salvador
  'HN': 'HNL', // Honduras
  'NI': 'NIO', // Nicaragua
  'CR': 'CRC', // Costa Rica
  'PA': 'USD', // Panama
  'CU': 'CUP', // Cuba
  'DO': 'DOP', // Dominican Republic
  'HT': 'HTG', // Haiti
  'JM': 'JMD', // Jamaica
  'TT': 'TTD', // Trinidad and Tobago
  'BB': 'BBD', // Barbados
  'BS': 'BSD', // Bahamas
  'AG': 'XCD', // Antigua and Barbuda
  'DM': 'XCD', // Dominica
  'GD': 'XCD', // Grenada
  'KN': 'XCD', // Saint Kitts and Nevis
  'LC': 'XCD', // Saint Lucia
  'VC': 'XCD', // Saint Vincent and the Grenadines
  'CO': 'COP', // Colombia
  'VE': 'VES', // Venezuela
  'GY': 'GYD', // Guyana
  'SR': 'SRD', // Suriname
  'BR': 'BRL', // Brazil
  'PE': 'PEN', // Peru
  'EC': 'USD', // Ecuador
  'BO': 'BOB', // Bolivia
  'PY': 'PYG', // Paraguay
  'UY': 'UYU', // Uruguay
  'AR': 'ARS', // Argentina
  'CL': 'CLP', // Chile
  'FK': 'FKP', // Falkland Islands
  
  // Asia
  'CN': 'CNY', // China
  'JP': 'JPY', // Japan
  'KR': 'KRW', // South Korea
  'KP': 'KPW', // North Korea
  'TW': 'TWD', // Taiwan
  'HK': 'HKD', // Hong Kong
  'MO': 'MOP', // Macao
  'MN': 'MNT', // Mongolia
  'IN': 'INR', // India
  'PK': 'PKR', // Pakistan
  'BD': 'BDT', // Bangladesh
  'LK': 'LKR', // Sri Lanka
  'NP': 'NPR', // Nepal
  'BT': 'BTN', // Bhutan
  'MM': 'MMK', // Myanmar
  'TH': 'THB', // Thailand
  'LA': 'LAK', // Laos
  'VN': 'VND', // Vietnam
  'KH': 'KHR', // Cambodia
  'MY': 'MYR', // Malaysia
  'SG': 'SGD', // Singapore
  'ID': 'IDR', // Indonesia
  'PH': 'PHP', // Philippines
  'BN': 'BND', // Brunei
  'TL': 'USD', // Timor-Leste
  'AF': 'AFN', // Afghanistan
  'IR': 'IRR', // Iran
  'IQ': 'IQD', // Iraq
  'IL': 'ILS', // Israel
  'JO': 'JOD', // Jordan
  'KW': 'KWD', // Kuwait
  'LB': 'LBP', // Lebanon
  'OM': 'OMR', // Oman
  'QA': 'QAR', // Qatar
  'SA': 'SAR', // Saudi Arabia
  'SY': 'SYP', // Syria
  'AE': 'AED', // United Arab Emirates
  'YE': 'YER', // Yemen
  'AM': 'AMD', // Armenia
  'AZ': 'AZN', // Azerbaijan
  'BH': 'BHD', // Bahrain
  'GE': 'GEL', // Georgia
  'KZ': 'KZT', // Kazakhstan
  'KG': 'KGS', // Kyrgyzstan
  'MV': 'MVR', // Maldives
  'TJ': 'TJS', // Tajikistan
  'TM': 'TMT', // Turkmenistan
  'UZ': 'UZS', // Uzbekistan
  
  // Oceania
  'AU': 'AUD', // Australia
  'NZ': 'NZD', // New Zealand
  'FJ': 'FJD', // Fiji
  'PG': 'PGK', // Papua New Guinea
  'SB': 'SBD', // Solomon Islands
  'VU': 'VUV', // Vanuatu
  'NC': 'XPF', // New Caledonia
  'PF': 'XPF', // French Polynesia
  'WS': 'WST', // Samoa
  'TO': 'TOP', // Tonga
  'TV': 'AUD', // Tuvalu
  'NR': 'AUD', // Nauru
  'KI': 'AUD', // Kiribati
  'PW': 'USD', // Palau
  'MH': 'USD', // Marshall Islands
  'FM': 'USD', // Micronesia
}

// Map of language codes to likely currencies (fallback)
const languageToCurrency: Record<string, string> = {
  'en': 'USD', // English - US Dollar (most common)
  'en-US': 'USD',
  'en-GB': 'GBP',
  'en-AU': 'AUD',
  'en-CA': 'CAD',
  'en-NZ': 'NZD',
  'en-ZA': 'ZAR',
  'en-IN': 'INR',
  'fr': 'EUR', // French - Euro (most common)
  'fr-FR': 'EUR',
  'fr-CA': 'CAD',
  'fr-CH': 'CHF',
  'fr-BE': 'EUR',
  'fr-MG': 'MGA', // French (Madagascar)
  'mg': 'MGA', // Malagasy
  'de': 'EUR', // German
  'de-DE': 'EUR',
  'de-AT': 'EUR',
  'de-CH': 'CHF',
  'es': 'EUR', // Spanish - Euro (Spain)
  'es-ES': 'EUR',
  'es-MX': 'MXN',
  'es-AR': 'ARS',
  'es-CO': 'COP',
  'es-CL': 'CLP',
  'es-PE': 'PEN',
  'pt': 'EUR', // Portuguese - Euro (Portugal)
  'pt-PT': 'EUR',
  'pt-BR': 'BRL',
  'it': 'EUR', // Italian
  'nl': 'EUR', // Dutch
  'pl': 'PLN', // Polish
  'ru': 'RUB', // Russian
  'ja': 'JPY', // Japanese
  'ko': 'KRW', // Korean
  'zh': 'CNY', // Chinese
  'zh-CN': 'CNY',
  'zh-TW': 'TWD',
  'zh-HK': 'HKD',
  'ar': 'SAR', // Arabic - Saudi Riyal (most common)
  'ar-SA': 'SAR',
  'ar-AE': 'AED',
  'ar-EG': 'EGP',
  'ar-DZ': 'DZD',
  'ar-MA': 'MAD',
  'hi': 'INR', // Hindi
  'bn': 'BDT', // Bengali
  'ur': 'PKR', // Urdu
  'id': 'IDR', // Indonesian
  'ms': 'MYR', // Malay
  'th': 'THB', // Thai
  'vi': 'VND', // Vietnamese
  'tr': 'TRY', // Turkish
  'he': 'ILS', // Hebrew
  'sw': 'KES', // Swahili - Kenyan Shilling (most common)
  'am': 'ETB', // Amharic
  'ha': 'NGN', // Hausa
  'yo': 'NGN', // Yoruba
  'ig': 'NGN', // Igbo
  'zu': 'ZAR', // Zulu
  'xh': 'ZAR', // Xhosa
  'af': 'ZAR', // Afrikaans
}

/**
 * Get the default currency based on browser locale and available information
 */
export function getDefaultCurrency(): string {
  try {
    // Try to get from browser's locale
    const locale = navigator.language || (navigator as any).userLanguage || 'en-US'
    
    // Parse locale to get country code (e.g., 'en-US' -> 'US')
    const parts = locale.split('-')
    const countryCode = parts.length > 1 ? parts[parts.length - 1].toUpperCase() : null
    
    // First, try to get currency from country code
    if (countryCode && countryToCurrency[countryCode]) {
      return countryToCurrency[countryCode]
    }
    
    // Second, try to get from full locale
    if (languageToCurrency[locale.toLowerCase()]) {
      return languageToCurrency[locale.toLowerCase()]
    }
    
    // Third, try to get from language code only
    const languageCode = parts[0].toLowerCase()
    if (languageToCurrency[languageCode]) {
      return languageToCurrency[languageCode]
    }
    
    // Try to get timezone-based detection as fallback
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    
    // Map some common timezones to currencies
    if (timezone) {
      if (timezone.includes('Madagascar') || timezone.includes('Antananarivo')) return 'MGA'
      if (timezone.includes('London')) return 'GBP'
      if (timezone.includes('Paris') || timezone.includes('Berlin')) return 'EUR'
      if (timezone.includes('Tokyo')) return 'JPY'
      if (timezone.includes('Shanghai') || timezone.includes('Beijing')) return 'CNY'
      if (timezone.includes('Sydney')) return 'AUD'
      if (timezone.includes('Mumbai') || timezone.includes('Kolkata')) return 'INR'
      if (timezone.includes('Johannesburg')) return 'ZAR'
      if (timezone.includes('Lagos')) return 'NGN'
      if (timezone.includes('Cairo')) return 'EGP'
      if (timezone.includes('Nairobi')) return 'KES'
      if (timezone.includes('Toronto')) return 'CAD'
      if (timezone.includes('Mexico')) return 'MXN'
      if (timezone.includes('Sao_Paulo')) return 'BRL'
      if (timezone.includes('Buenos_Aires')) return 'ARS'
    }
    
    // Default to USD if nothing matches
    return 'USD'

  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('Error detecting default currency:', error)
    }
    return 'USD'
  }
}

/**
 * Get currency symbol for a given currency code
 */
export function getCurrencySymbol(currencyCode: string): string {
  const symbols: Record<string, string> = {
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'JPY': '¥',
    'CNY': '¥',
    'INR': '₹',
    'KRW': '₩',
    'MGA': 'Ar',
    'ZAR': 'R',
    'NGN': '₦',
    'KES': 'KSh',
    'EGP': 'ج.م',
    'MAD': 'د.م.',
    'GHS': '₵',
    'XOF': 'CFA',
    'XAF': 'FCFA',
    // Add more as needed
  }
  
  return symbols[currencyCode] || currencyCode
}

/**
 * Format currency value using standard Intl.NumberFormat
 */
export function formatCurrencyValue(amount: number, currencyCode: string): string {
  try {
    // Use standard Intl.NumberFormat for proper formatting
    const formatter = new Intl.NumberFormat(navigator.language || 'en-US', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    
    return formatter.format(amount)
  } catch (error) {
    // Fallback to manual formatting if currency code is invalid
    const symbol = getCurrencySymbol(currencyCode)
    const formattedAmount = amount.toFixed(2)
    
    // For some currencies, symbol goes after the amount
    if (['EUR', 'XOF', 'XAF', 'MGA'].includes(currencyCode)) {
      return `${formattedAmount} ${symbol}`
    }
    
    return `${symbol}${formattedAmount}`
  }
}

// Export for use in stores and components
export default {
  getDefaultCurrency,
  getCurrencySymbol,
  formatCurrencyValue,
  countryToCurrency,
  languageToCurrency
}